import React, { FC, memo } from 'react';
import { DivStatusLabel } from './styles';
import { SUBMISSION_BOM_STATUS_MAP, SUBMISSION_KSF_STATUS_MAP } from './constants';

type Props = {
  status: number;
  isKSF?: boolean;
};

const SubmissionStatus: FC<Props> = ({ status, isKSF = false }) => {
  if (!isKSF && !SUBMISSION_BOM_STATUS_MAP[status]) {
    return null;
  }
  if (isKSF && !SUBMISSION_KSF_STATUS_MAP[status]) {
    return null;
  }

  return (
    <DivStatusLabel status={status}>
      {isKSF ? SUBMISSION_KSF_STATUS_MAP[status] : SUBMISSION_BOM_STATUS_MAP[status]}
    </DivStatusLabel>
  );
};

export default memo(SubmissionStatus);
